import { render, staticRenderFns } from "./CompetitorExpiringContractsSection.vue?vue&type=template&id=586244e5&scoped=true"
import script from "./CompetitorExpiringContractsSection.vue?vue&type=script&lang=js"
export * from "./CompetitorExpiringContractsSection.vue?vue&type=script&lang=js"
import style0 from "./CompetitorExpiringContractsSection.vue?vue&type=style&index=0&id=586244e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586244e5",
  null
  
)

export default component.exports